import variables from "theme/variables";
import styled from "styled-components";

const Container = styled.div`
  text-align: center;
  padding: ${variables.SPACING * 4}px;
  overflow: scroll;
  height: 100%;

  form {
    max-width: 1600px;
    margin: auto;
  }

  input {
    max-width: 600px;
    margin: 0 auto;
  }
`;

const Field = styled.div`
  display: block;
  margin-bottom: ${variables.SPACING * 4}px;
  min-width: 300px;

  &:last-child {
    margin-bottom: 8;
  }

  > * {
    display: block;
    width: 100%;

    &:first-child {
      margin-bottom: ${variables.SPACING * 2}px;
      font-weight: 600;
    }
  }
`;

const SkillsLevels = styled.div`
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  grid-gap: ${variables.SPACING * 2}px;
`;

const Skills = styled.div``;

const SkillStar = styled.div`
  padding: ${variables.SPACING * 2}px;

  svg {
    margin-left: ${variables.SPACING}px;
  }
`;

const SkillsInput = styled.div`
  margin-bottom: ${variables.SPACING}px;

  > div {
    &:first-child {
      width: 80%;
      margin-right: 8px;
    }
  }
`;

const AddSkill = styled.div`
  padding: 8px;
  color: black;
  background: white;
  border-radius: 5px;
  margin-top: 16px;
  text-transform: uppercase;
`;

const TrainerPageStyles = {
  Container,
  Field,
  SkillsLevels,
  Skills,
  SkillStar,
  SkillsInput,
  AddSkill,
};

export default TrainerPageStyles;
